/* eslint-disable max-len */
import 'react';

const SuccessNewSvg = () => (
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="mask0_10454_1857" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
            <rect width="48" height="48" fill="black" />
        </mask>
        <g mask="url(#mask0_10454_1857)">
            <path d="M24.0001 6C33.9412 6 42.0001 14.0589 42.0001 24C42.0001 33.9411 33.9412 42 24.0001 42C14.0589 42 6.00006 33.9411 6.00006 24C6.00006 14.0589 14.0589 6 24.0001 6Z" fill="#4AD46C" />
            <path d="M17.1301 23.4648L22.8344 29.4292" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M32.2034 20L22.8343 29.429" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
);

export default SuccessNewSvg;
